import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { type HTMLAttributes, useContext, useEffect, useState } from 'react';

import SoundDisableSvg from '@/components/Icon/svgs/sounds-off.svg';
import SoundSvg from '@/components/Icon/svgs/sounds-on.svg';
import HomeContext from '@/context/HomeContext';
import useGenius from '@/hooks/useGenius';
import useGeniusLayout from '@/hooks/useGeniusLayout';
import { useModel } from '@/hooks/useModel';
import VoiceSettingsModal from '@/layouts/PA-Layout/VoiceModal';
import { getMuteStatus, setMuteStatus } from '@/service/chat';
import { EVENT } from '@/utils/event';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';
import { EBiz } from '@/utils/report/report_biz';

import CloseIcon from './CloseIcon';
import FullScreenIcon from './FullScreenIcon';
import styles from './index.less';

export interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function RightContainer(props: IProps): JSX.Element {
  const { className } = props;
  const { isLogin } = useModel('auth-model', (model) => ({ isLogin: model.isLogin }));
  const { type } = useGeniusLayout();
  const { mindId, setContext } = useContext(HomeContext);
  // pa 或者 自己创建的影子心识
  const geniusInfo = useGenius();

  const isMute = geniusInfo.voice?.data?.isMute;
  const [isMuteVoice, setMuteVoice] = useState<boolean>(true);

  const [open, setOpen] = useState(false);

  const setMute = () => {
    const nextStatus = !isMuteVoice;

    if (!mindId) return;

    setMuteVoice(nextStatus);

    setMuteStatus({ mindId: mindId!, status: nextStatus ? 'mute' : 'unmute' });
  };

  const queryMuteStatus = () => {
    getMuteStatus({ mindId: mindId! }).then((res) => {
      const { data } = res;

      if (data.code === 0) {
        setMuteVoice(data.data === 'mute');
      }
    });
  };

  useEffect(() => {
    if (mindId && isLogin) {
      queryMuteStatus();
    }
  }, [mindId, isLogin]);

  useEffect(() => {
    setContext({ voiceMute: isMuteVoice });
  }, [isMuteVoice]);

  useEffect(() => {
    const switchVoice = () => {
      setMuteVoice((m) => !m);
    };

    addEventListener(EVENT.SWITCH_VOICE_MUTE, switchVoice);

    return () => {
      removeEventListener(EVENT.SWITCH_VOICE_MUTE, switchVoice);
    };
  }, []);

  return (
    <div className={classNames(className)}>
      {/* Voice */}
      {isLogin && type !== 'log' && (
        <div
          className={classNames(styles.buttonItem, { [styles.onlyIcon]: true })}
          id="voiceIcon"
          onClick={() => {
            reportClick(EReportClickKey.click_mute_voice, { key1: mindId }, EBiz.chat_container);

            if (isMute) {
              setOpen(true);
            } else {
              setMute();
            }
          }}
        >
          <Icon
            className={classNames(styles.icon, { [styles.isMute]: isMuteVoice })}
            component={!isMuteVoice ? SoundSvg : SoundDisableSvg}
          />
        </div>
      )}
      {isLogin && type !== 'log' ? (
        <VoiceSettingsModal
          handleClose={() => setOpen(false)}
          handleConfirmCb={() => setOpen(false)}
          open={open}
        />
      ) : null}
      {/* FullScreen */}
      <FullScreenIcon />
      {/* HideScreen */}
      <CloseIcon />
    </div>
  );
}
